module.exports = __webpack_public_path__ + "static/media/materialy-do-pobrania.57fc8c06.png";